<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-card>
      <v-form ref="formConfColegio" lazy-validation>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="pb-0">
              <v-alert dense border="left" class="text-center" color="primary" dark>
                <h2>CONFIGURACIÓN DEL COLEGIO</h2>
              </v-alert>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="6" class="py-0 my-2">
              <div class="question-with-icon">
                <h3>¿Restringir al estudiante la visualización del contenido de las clases si no está ejecutada?</h3>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" style="color: red;">fa-info-circle</v-icon>
                  </template>
                  <div style="max-width: 500px;text-align: justify;">
                    <span>Esta configuración permite controlar el acceso anticipado de los estudiantes al material de
                      las clases. Si se
                      activa, los estudiantes podrán ver las diapositivas antes de que el docente los presente
                      oficialmente en la fecha
                      programada. Esto es útil si deseas que los estudiantes se preparen previamente para la clase. Si
                      se desactiva, los
                      contenidos solo serán accesibles cuando el docente cambie el estado de la clase a
                      ejecutada.</span>
                  </div>
                </v-tooltip>
              </div>
              <v-radio-group v-model="dataForm.res_visualizar_cont_alumno_prog_doc" hide-details>
                <v-radio label="Sí" :value="1" color="teal"></v-radio>
                <v-radio label="No" :value="0" color="error"></v-radio>
              </v-radio-group>
            </v-col>


            <v-col cols="12" sm="12" md="6" lg="6" class="py-0 my-2">
              <h3>¿Restringir al docente el cierre de la programación si no está adjunto el enlace del video de la clase
                grabada?</h3>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" style="color: red;">fa-info-circle</v-icon></template>
                <div style="max-width: 500px;text-align: justify;">
                  <span>Esta configuración asegura que el enlace al video de la clase grabada esté presente antes de
                    permitir que el
                    docente cambie el estado de programado a ejecutado. El cierre de la programación solo es posible una
                    vez que el
                    docente ha insertado el enlace del video, garantizando así que los estudiantes tendrán acceso al
                    material
                    audiovisual para su revisión o estudio posterior a la clase.</span>
                </div>
              </v-tooltip>
              <v-radio-group v-model="dataForm.res_adjuntar_video_cierre_prog_doc" hide-details>
                <v-radio label="Sí" :value="1" color="teal"></v-radio>
                <v-radio label="No" :value="0" color="error"></v-radio>
              </v-radio-group>
            </v-col>


            <v-col cols="12" sm="12" md="6" lg="6" class="py-0 my-2">
              <h3>Listado de sección visualizado por el estudiante:</h3>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" style="color: red;">fa-info-circle</v-icon>
                </template>
                <div style="max-width: 500px;text-align: justify;">
                  <span>Esta configuración permite el listado de sección mostrado al estudiante incluirá una imagen
                    (previa
                    configuración en el listado de usuario) y el correo electrónico de cada uno, lo que permite la
                    identificación
                    visual de los estudiantes.</span>
                </div>
              </v-tooltip>
              <v-checkbox v-model="dataForm.rest_estudiante_seccion_avatar" label="Imagen (avatar)"
                hide-details></v-checkbox>
              <v-checkbox v-model="dataForm.rest_estudiante_seccion_correo" label="Correo" hide-details></v-checkbox>
            </v-col>



            <v-col cols="12" sm="12" md="6" lg="6" class="py-0 my-2">
              <h3>Listado de docentes visualizado por el estudiante:</h3>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" style="color: red;">fa-info-circle</v-icon>
                </template>
                <div style="max-width: 500px;text-align: justify;">
                  <span>Esta configuración permite a los estudiantes visualizar un listado de los docentes asignados a
                    cada sección,
                    junto con su imagen (previa configuración en el listado de usuario), correo electrónico y télefono.
                    Esto permite
                    a los estudiantes reconocer fácilmente a sus docentes.</span>
                </div>
              </v-tooltip>
              <v-checkbox v-model="dataForm.rest_estudiante_docente_avatar" label="Imagen (avatar)"
                hide-details></v-checkbox>
              <v-checkbox v-model="dataForm.rest_estudiante_docente_correo" label="Correo" hide-details></v-checkbox>
              <v-checkbox v-model="dataForm.rest_estudiante_docente_curso" label="Télefono" hide-details></v-checkbox>
            </v-col>

            <v-col cols="12" sm="12" md="6" lg="6" class="py-0 my-2">
              <h3>Listado de docentes visualizado por el padre de familia:</h3>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" style="color: red;">fa-info-circle</v-icon>
                </template>
                <div style="max-width: 500px;text-align: justify;">
                  <span>Esta configuración permite a los padres de familia pueden acceder a un listado de los docentes
                    de la sección
                    de sus hijos, incluyendo una imagen (previa configuración en el listado de usuario), correo
                    electrónico y
                    télefono. Esto permite a los padre de familia reconocer fácilmente a los docentes asignado a su
                    hijo.</span>
                </div>
              </v-tooltip>
              <v-checkbox v-model="dataForm.rest_padre_familia_avatar" label="Imagen (avatar)"
                hide-details></v-checkbox>
              <v-checkbox v-model="dataForm.rest_padre_familia_correo" label="Correo" hide-details></v-checkbox>
              <v-checkbox v-model="dataForm.rest_padre_familia_telf" label="Teléfono" hide-details></v-checkbox>
            </v-col>


            <v-col cols="12" sm="12" md="6" lg="6" class="py-0 my-2">
              <div>
                <h3>Para registrar las notas conductuales se tomará en cuenta:</h3>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" style="color: red;">fa-info-circle</v-icon>
                  </template>
                  <div style="max-width: 500px;text-align: justify;">
                    <span>Esta configuración permite que la asistencia del estudiante influirá en el registro de notas
                      conductuales,
                      Esto promueve la responsabilidad y la puntualidad entre los estudiantes.</span>
                  </div>
                </v-tooltip>
                <v-radio-group v-model="notasconductuales" mandatory>
                  <v-radio label="La asistencia al colegio" value="asistencia_colegio"></v-radio>
                  <v-radio label="La asistencia a la clase" value="asistencia_clase"></v-radio>
                  <v-radio label="Ambas asistencias" value="ambas_asistencias"></v-radio>
                  <v-radio label="Ninguna" value="ninguna_asistencia"></v-radio>

                </v-radio-group>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <h3>Enviar las notificaciones de pendientes por correo al familiar:</h3>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" style="color: red;">fa-info-circle</v-icon>
                </template>
                <div style="max-width: 500px;text-align: justify;">
                  <span>Esta configuración permite que los familiares puedan recibir las notificaciones a travez del
                    correo las
                    tareas que los alumnos
                    tienen
                    pendiente.</span>
                </div>
              </v-tooltip>
              <v-switch v-model="automaticReport" :label="automaticReport ? 'Si' : 'No'"
                @click="clearautomaticReport()"></v-switch>
              <template v-if="automaticReport">
                <v-checkbox v-model="dataForm.rest_report_actividades" label="Reporte de actividades"
                  hide-details></v-checkbox>
                <v-checkbox v-model="dataForm.rest_report_evaluaciones" label="Reporte de evaluaciones"
                  hide-details></v-checkbox>

              </template>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <h5 class="error--text px-2">
            *De no haber realizado ningún cambio, pasar al siguiente
            submódulo
          </h5>
          <v-spacer></v-spacer>
          <TableButtonComp v-if="componenteEvento.editar_submodulo" normalButton @click="saveItem()"
            textButton="Guardar cambios" iconBut="fas fa-save" />
          <!-- <v-btn class="btn_block_style2" dark  @click="saveItem()"
                        v-if="componenteEvento.editar_submodulo">Guardar Cambios</v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "../../helpers/axios";
import TableButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    TableButtonComp,
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 65, id_modulo: 5 }, //sud_modulo y modulo
    mensaje: { tipo: null, mensaje: null, tiempo: null }, // mensaje de sistema
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    notasconductuales: null,
    datos: {},
    dataForm: {},
    automaticReport: false,
    i18n: [],
    vizualizarDocentesFamilia: {},
    vizualizarSeccionEstudiante: {},
    vizualizarDocentesEstudiante: {},
    conductuales: {
      asistencia_colegio: false,
      asistencia_clase: false,
      ambas_asistencias: false,
      ninguna_asistencia: false,
    },
  }),

  mounted() {
    this.notasconductuales = this.vModelFromBackend;
  },

  created() {
    this.loadMain();
    this.actualizarParamentro();

  },

  computed: {
    ...mapGetters("login", ["componenteEvento"]),

    vModelFromBackend() {
      if (this.dataForm.rest_notas_conductuales_asistencia_ambas) {
        return 'ambas_asistencias';
      } else if (this.dataForm.rest_notas_conductuales_asistencia_clase) {
        return 'asistencia_clase';
      } else if (this.dataForm.rest_notas_conductuales_asistencia_colegio) {
        return 'asistencia_colegio';
      } else {
        return 'ninguna_asistencia';
      }
    },
  },

  watch: {
    // Watcher para actualizar el valor del v-model cuando cambia la respuesta del backend
    vModelFromBackend(newVal) {
      this.notasconductuales = newVal;
    }
  },



  //metodos
  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //-------mostrar registros------------
    async loadMain() {
      try {
        let resp = await axios.get(
          `/sistema/configColegio/getQuery/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`
        );
        console.log({ DATA: resp.data })
        this.dataForm = resp.data.Config;

        if (this.dataForm.rest_report_actividades == true || this.dataForm.rest_report_evaluaciones == true) {
          this.automaticReport = true
        } else {
          this.automaticReport = false
        }
        this.i18n = resp.data.I18n;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: error, tiempo: "null" });
      }
    },

    async saveItem() {
      console.log('Item seleccionado', this.notasconductuales);

      const updateDataForm = (asistenciaColegio, asistenciaClase, asistenciaNinguna, asistenciaAmbas) => {
        this.dataForm = {
          ...this.dataForm,
          rest_notas_conductuales_asistencia_colegio: asistenciaColegio,
          rest_notas_conductuales_asistencia_clase: asistenciaClase,
          rest_notas_conductuales_asistencia_ninguna: asistenciaNinguna,
          rest_notas_conductuales_asistencia_ambas: asistenciaAmbas
        }
      };

      switch (this.notasconductuales) {
        case 'ambas_asistencias':
          updateDataForm(false, false, false, true);
          break;
        case 'asistencia_clase':
          updateDataForm(false, true, false, false);
          break;
        case 'asistencia_colegio':
          updateDataForm(true, false, false, false);
          break;
        case 'ninguna_asistencia':
          updateDataForm(false, false, true, false);
          break;
      }



      if (this.$refs.formConfColegio.validate()) {
        try {
          let resp = await axios.put(
            `/sistema/configColegio/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`,
            this.dataForm
          );
          this.setEnviarMens({
            tipo: resp.data.messageT,
            mensaje: `¡Información editada con éxito!`,
            tiempo: "null",
          });
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: error, tiempo: "null" });
        }
      }
    },

    async clearautomaticReport() {
      this.dataForm = {
        ...this.dataForm,
        rest_report_actividades: false,
        rest_report_evaluaciones: false,
        rest_report_somoshabiles: false

      }
    }

  }
};
</script>

<style scoped>
h3 {
  color: var(--v-secondary-darken3);
}
</style>
